import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { ModalUI } from '../../common';

const ModalEncender = (props) => {
  let { handleSubmit, modalHandler, modal_state, form_state } = props;

  return (
    <ModalUI
      open={modal_state}
      id="apagar_temporalmente_encender"
      title="Encender tienda"
      modalHandler={modalHandler}
      aditional_param="apagar_temporalmente_encender"
      handleSubmit={handleSubmit}
      button_label="Encender"
      button_disabled={false}
      button_loading={form_state}
    >
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <Typography>
            ¿Está seguro de que quiere encender su tienda? Sus clientes podrán
            volver a comprar productos.
          </Typography>
        </Grid>
      </Grid>
    </ModalUI>
  );
};

export { ModalEncender };
